
import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';

import { IFormTextarea } from '../../_shared/models';
import { TextareaComponent } from '../../textarea/textarea.component';
import { FormElementBase } from '../_directives/form-element-base.directive';

@Component({
    selector: 'sirius-form-textarea',
    templateUrl: './form-textarea.component.html',
    styles: [],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [ReactiveFormsModule, TextareaComponent]
})
export class FormTextareaComponent extends FormElementBase implements OnInit {
    config?: IFormTextarea;

    toolTip = '';

    ngOnInit(): void {
        if (this.config) {
            this.name = this.config.name;
            this.label = this.config.label;
            this.formFieldDependencies = this.config.dependentFormFieldComponents;
            this.validation = this.config.validation;
            this.form = this.config.form;
            this.identifier = this.config.identifier ?? '';
            this.toolTip = this.config.toolTip ?? '';
        }
    }
}
